var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "disabled";
},"3":function(container,depth0,helpers,partials,data) {
    return "active";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"divider\"></div>\n\n<div class=\"mi mi-cb-mixed-with-dd-icon toggle-overlay "
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hasImageOverlay : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showImgOverlay : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" title=\"Overlay\">\n    Overlay\n</div>\n<div class=\"mi mi-cb-mixed-with-dd-icon toggle-greenBar "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showGreenbar : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" title=\"Green Bar\">\n    Green Bar\n</div>\n<div class=\"mi mi-cb-mixed-with-dd-icon toggle-text-selection disabled\" title=\"Enable Text Selection When Annotating\">\n    Text Selection\n</div>\n";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/overlay/textPageDropdown/partial.hbs
 ** module id = 472
 ** module chunks = 0
 **/